import * as typography from "@client/shared/typography";
import {Layout} from "@client/site/Layout";
import React from "react";

export const Template = () => (
    <Layout title="Page Not Found">
        <typography.Header>Page Not Found</typography.Header>
        <typography.P>Make sure to check for typos.</typography.P>
    </Layout>
);
